import VueHighcharts from 'vue2-highcharts'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting.js'
// import Stock from 'highcharts/modules/stock.js'
import More from 'highcharts/highcharts-more'
Exporting(Highcharts)
// Stock(Highcharts)
More(Highcharts)
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
})

export default {
  name: 'LineChart',
  props: {
    analyzeTargetCode: String,
    historyId: Number,
    chartOption: Object
  },
  components: {
    VueHighcharts: VueHighcharts
  },
  mounted () {

  },
  data: () => ({
    Highcharts: Highcharts,
    basicData: {
      chart: {
        type: 'spline'
      },
      title: {
        text: '性年代別購入者分析'
      },
      subtitle: {
        text: '10歳刻み・男性'
      },
      xAxis: {
        categories: [
          '10歳未満',
          '10代',
          '20代',
          '30代',
          '40代',
          '50代',
          '60代',
          '70代',
          '80歳以上'
        ]
      },
      yAxis: {
        title: {
          text: '購入指数(%)'
        },
        labels: {
          formatter: function () {
            return this.value + ''
          }
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 4,
            lineColor: '#058DC7',
            lineWidth: 1
          }
        }
      },
      series: [
        {
          name: '購入指数(%)',
          data: [
            7.0,
            6.9,
            9.5,
            14.5,
            18.2,
            21.5,
            25.2,
            {
              y: 26.5,
              marker: {
                symbol: 'url(http://www.highcharts.com/demo/gfx/sun.png)'
              }
            },
            23.3,
            18.3,
            13.9,
            9.6
          ]
        }
      ]
    }
  })
}
